// Textos en español. Debe reflejar la estructura de it.js (las claves que falten usan el italiano).
import legal from "./legal/es";
import home from "./home/es";

const es = {
  meta: {
    description:
      "Qapex: Transformación digital, automatización, innovación. Desarrollamos soluciones de software a medida para hacer crecer tu negocio.",
  },

  contactForm: {
    options: {
      "QA Service Provider": "QA Service Provider",
      "QA Consulting": "QA Consulting",
      "QUACK": "QUACK",
      "SubQ": "SubQ",
      "Sviluppo Custom": "Desarrollo de software a medida",
    },
    sending: "Enviando...",
    submit: "ENVIAR",
    success: "¡Mensaje enviado! Te contactaremos lo antes posible.",
    error: "Error en el envío. Inténtalo de nuevo.",
    privacy: "Declaro haber leído la <link>Política de privacidad</link> y consiento el tratamiento de mis datos para gestionar la presente solicitud.",
  },

  workWithUs: {
    eyebrow: "Trabaja con nosotros",
    heroTitle: "Únete a",
    heroHighlight: "nuestro equipo.",
    heroText: "Construye con nosotros el futuro de la calidad y de la innovación digital.",
    openPositions: "Posiciones abiertas",
    apply: "Postúlate",
    applyNow: "Envía tu candidatura",
    positions: [
      {
        id: "Software Tester",
        title: "Software Tester",
        description:
          "Buscamos un Software Tester detallista. Serás responsable de ejecutar los casos de prueba, hacer el seguimiento de los bugs y garantizar la máxima calidad de nuestros productos de software. Se requiere experiencia en pruebas manuales; la automatización es un plus.",
      },
      {
        id: "QA Engineer",
        title: "QA Engineer",
        description:
          "Únete a nosotros como QA Engineer para diseñar e implementar estrategias de prueba. Debes dominar las herramientas de pruebas automatizadas y los pipelines CI/CD, y conocer a fondo el ciclo de vida del desarrollo de software.",
      },
      {
        id: "Full Stack Developer",
        title: "Full Stack Developer",
        description:
          "Buscamos un Desarrollador Full Stack para construir aplicaciones web escalables. Es imprescindible dominar React, Node.js y las tecnologías modernas de bases de datos. Trabajarás codo con codo con nuestros equipos de diseño y QA para ofrecer experiencias de usuario excepcionales.",
      },
      {
        id: "Partner Commerciale",
        title: "Partner Comercial",
        description:
          "QAPEX SRL busca un Agente Comercial – Leads cualificados incluidos\nBuscamos un agente comercial autónomo para desarrollar nuevas oportunidades B2B.\n¿La diferencia con la actividad comercial clásica? Los leads los ponemos nosotros.\nTe proporcionamos una lista de empresas ya seleccionadas y cualificadas, para que puedas dedicar tu tiempo a la actividad comercial: contacto, relación, negociación y cierre.",
      },
    ],
  },

  applyModal: {
    title: "Inscríbete ahora",
    close: "Cerrar",
    fullName: "Nombre completo",
    namePlaceholder: "Juan García",
    position: "Puesto",
    selectPosition: "Selecciona un puesto",
    email: "Correo electrónico",
    emailPlaceholder: "juan@example.com",
    uploadCv: "Sube tu currículum",
    uploadCvHint: "Haz clic para subir tu CV",
    privacy: "Acepto la <link>Política de privacidad</link> y consiento el tratamiento de mis datos personales.",
    submitting: "ENVIANDO...",
    submit: "ENVIAR CANDIDATURA",
    autoresponse: "Hemos recibido tu candidatura y nos pondremos en contacto contigo en breve.",
    fileTooLarge: "El archivo es demasiado grande. Tamaño máximo: 5MB.",
    fileTypeInvalid: "Tipo de archivo no compatible. Sube un PDF o un documento Word.",
    cvRequired: "Por favor, sube tu currículum.",
    privacyRequired: "Por favor, acepta la política de privacidad.",
  },

  legal,
  home,
};

export default es;
